var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9182 48H5.92948C5.73495 47.952 5.54042 47.9039 5.34589 47.857C2.7162 47.223 0.978312 45.0246 0.973625 42.2848C0.96425 37.1391 0.971281 31.9934 0.971281 26.8477C0.971281 21.0785 0.965422 15.3082 0.973625 9.53906C0.978312 6.80039 2.71152 4.55156 5.35292 3.99257C6.29862 3.79218 7.30409 3.87187 8.28261 3.82617C8.46073 3.81797 8.63886 3.82617 8.85097 3.82617V0.116013H12.5834V3.80039H37.2865V0.119528H41.0353V3.82968C41.8451 3.82968 42.6221 3.80625 43.3967 3.83437C45.2037 3.9 46.6557 4.66523 47.7642 6.09609C48.3818 6.89297 48.6654 7.82343 48.8787 8.78672V43.0406C48.8506 43.1285 48.8096 43.2129 48.7943 43.3031C48.5353 44.8312 47.7572 46.0336 46.5209 46.9535C45.7439 47.5301 44.8451 47.7973 43.9193 48.0012L43.9182 48ZM4.71308 17.6977V18.1945C4.71308 26.1492 4.71308 34.1027 4.71308 42.0574C4.71308 43.5434 5.43144 44.257 6.92558 44.257C18.9162 44.257 30.908 44.257 42.8986 44.257C44.4256 44.257 45.1346 43.5527 45.1346 42.034C45.1346 34.0957 45.1346 26.1562 45.1346 18.218C45.1346 18.0516 45.1346 17.884 45.1346 17.6977H4.71308ZM4.72011 13.9008H45.1287C45.1287 12.3574 45.151 10.8457 45.1205 9.33515C45.1017 8.45039 44.4373 7.69218 43.5619 7.61132C42.7322 7.53515 41.8908 7.59492 41.0037 7.59492V11.2734H37.2537V7.60195H12.5623V11.284H8.8123V7.575C7.99784 7.575 7.23495 7.54804 6.47323 7.58203C5.51816 7.62539 4.74941 8.37539 4.72714 9.33047C4.69198 10.841 4.71777 12.3527 4.71777 13.8996L4.72011 13.9008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71289 17.6977H45.1355C45.1355 17.884 45.1355 18.0516 45.1355 18.218C45.1355 26.1563 45.1355 34.0957 45.1355 42.034C45.1355 43.5516 44.4266 44.257 42.8996 44.257C30.909 44.257 18.9172 44.257 6.92656 44.257C5.43242 44.257 4.71406 43.5434 4.71406 42.0574C4.71406 34.1027 4.71406 26.1492 4.71406 18.1945V17.6977H4.71289ZM8.09844 25.3137H11.798V21.6375H8.09844V25.3137ZM19.2828 25.3289V21.6375H15.6008V25.3289H19.2828ZM23.075 25.3195H26.7594V21.6305H23.075V25.3195ZM34.2512 25.3418V21.6398H30.5738V25.3418H34.2512ZM38.0598 21.6246V25.3266H41.7371V21.6246H38.0598ZM11.8027 29.1281H8.11836V32.8137H11.8027V29.1281ZM19.2758 32.8172V29.1316H15.5914V32.8172H19.2758ZM23.0691 32.8008H26.7699V29.1223H23.0691V32.8008ZM30.5574 32.8031H34.2418V29.1211H30.5574V32.8031ZM41.7312 32.8184V29.1164H38.0504V32.8184H41.7312ZM8.10078 40.2891H11.8016V36.6082H8.10078V40.2891ZM19.2887 36.6059H15.5961V40.2902H19.2887V36.6059ZM26.7734 36.6129H23.0891V40.2996H26.7734V36.6129ZM34.2617 36.6023H30.5645V40.2926H34.2617V36.6023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7181 13.9008C4.7181 12.3539 4.69232 10.8422 4.72747 9.33165C4.74974 8.3754 5.51732 7.6254 6.47357 7.58321C7.23411 7.54923 7.99818 7.57618 8.81263 7.57618V11.2852H12.5626V7.60313H37.254V11.2746H41.004V7.5961C41.8911 7.5961 42.7326 7.53634 43.5622 7.61251C44.4365 7.69337 45.1021 8.45157 45.1208 9.33634C45.1513 10.8469 45.129 12.3586 45.129 13.902H4.7181V13.9008Z",
    fill: "#F89B60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09766 25.3137V21.6375H11.7973V25.3137H8.09766Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2816 25.3289H15.5996V21.6375H19.2816V25.3289Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 25.3195V21.6305H26.7586V25.3195H23.0742Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2516 25.343H30.5742V21.641H34.2516V25.343Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0586 21.6246H41.7359V25.3266H38.0586V21.6246Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8016 29.1281V32.8137H8.11719V29.1281H11.8016Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2762 32.8172H15.5918V29.1316H19.2762V32.8172Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0684 32.802V29.1234H26.7691V32.802H23.0684Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5566 32.8043V29.1223H34.241V32.8043H30.5566Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7316 32.8195H38.0508V29.1176H41.7316V32.8195Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09961 40.2902V36.6094H11.8004V40.2902H8.09961Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2883 36.607V40.2914H15.5957V36.607H19.2883Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7723 36.6152V40.302H23.0879V36.6152H26.7723Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2617 36.6047V40.2949H30.5645V36.6047H34.2617Z",
    fill: "#F36D55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.876953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.3127a98691556001ab73fc45b46a854f.svg";
export { ForwardRef as ReactComponent };